/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the PoliticalCampaign HTTP resource (factory product). */
export class PoliticalCampaignResource {
}

export function createPoliticalCampaignResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'politicalcampaigns',
    () => localUserProfile
  );
}

export const politicalCampaignResourceProvider = {
  provide: PoliticalCampaignResource,
  useFactory: createPoliticalCampaignResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

